(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-products-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.section-collection-products-slider .swiper').
        forEach(function(slider) {
              const section = slider.closest('.collection-products-slider');
              if (!section) return;
              const prevEl = section.querySelector('.slider-buttons .prev');
              const nextEl = section.querySelector('.slider-buttons .next');

            var swiper = new Swiper(slider, {
                slidesPerView: 2.2,
                spaceBetween: 5,
                mousewheel: {
                    forceToAxis: true,
                },
                freeMode: true,
                grid: {
                    fill: 'row',
                },
                navigation: { prevEl: prevEl, nextEl: nextEl },
                breakpoints: {
                  768:  { slidesPerView: 2, spaceBetween: 5, grid: { rows: 2} },
                  1280: { slidesPerView: 3, spaceBetween: 5, grid: { rows: 2} }
                }
            });
        });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    /* Mega menu */
// === CONFIGURATION ===
  const triggerMode = "hover"; 
  // Change to "hover" to activate on hover instead of click
  // Example: const triggerMode = "hover";
  // ======================

  const submenuLinks = document.querySelectorAll('.open-mega-submenu');

  function closeSubmenu(link) {
    const submenu = link.nextElementSibling;
    if (!submenu || !submenu.classList.contains('mega-submenu')) return;

    submenu.style.maxHeight = submenu.scrollHeight + 'px';
    submenu.offsetHeight; // force reflow
    submenu.style.maxHeight = '0px';
    link.classList.remove('open');
  }

  function openSubmenu(link) {
    const submenu = link.nextElementSibling;
    if (!submenu || !submenu.classList.contains('mega-submenu')) return;

    link.classList.add('open');
    submenu.style.maxHeight = submenu.scrollHeight + 'px';
  }

  function closeAll() {
    submenuLinks.forEach(link => closeSubmenu(link));
  }

  if (triggerMode === "click") {
    // ----- CLICK MODE -----
    submenuLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        const isOpen = this.classList.contains('open');

        submenuLinks.forEach(other => {
          if (other !== this) closeSubmenu(other);
        });

        if (isOpen) {
          closeSubmenu(this);
        } else {
          openSubmenu(this);
        }
      });
    });

    // Click outside closes all
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.mega-menu')) {
        closeAll();
      }
    });

  } else if (triggerMode === "hover") {
    // ----- HOVER MODE -----
    submenuLinks.forEach(link => {
      const submenu = link.nextElementSibling;
      if (!submenu || !submenu.classList.contains('mega-submenu')) return;

      link.addEventListener('mouseenter', () => {
        submenuLinks.forEach(other => {
          if (other !== link) closeSubmenu(other);
        });
        openSubmenu(link);
      });

      link.addEventListener('mouseleave', (e) => {
        // If leaving to the submenu, don't close immediately
        const submenuRect = submenu.getBoundingClientRect();
        const to = e.relatedTarget;
        if (!to || !submenu.contains(to)) {
          closeSubmenu(link);
        }
      });

      submenu.addEventListener('mouseleave', () => {
        closeSubmenu(link);
      });
    });
  }

  // Adjust open submenu heights on window resize
  window.addEventListener('resize', () => {
    document.querySelectorAll('.open-mega-submenu.open').forEach(link => {
      const submenu = link.nextElementSibling;
      if (submenu && submenu.classList.contains('mega-submenu')) {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      }
    });
  });

const preview = document.createElement('div');
  preview.id = 'menu-hover-preview';
  Object.assign(preview.style, {
    position: 'fixed',
    left: '0px',
    top: '0px',
    display: 'none',
    pointerEvents: 'none',
    zIndex: '9999',
    boxShadow: '0 6px 24px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)',
    backdropFilter: 'blur(2px)',
    transform: 'translate(0, 0)'
  });

  const img = document.createElement('img');
  Object.assign(img.style, {
    display: 'block',
    width: '250px',
    height: '165px',
    objectFit: 'cover',
    objectPosition: 'center center'
  });

  preview.appendChild(img);
  document.body.appendChild(preview);

  const OFFSET_Y = 22; // vertical distance below cursor

  let rafId = null;
  let lastEvent = null;

  function positionPreview(e) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const rect = preview.getBoundingClientRect();

    // desired position: centered below cursor
    let x = e.clientX;
    let y = e.clientY + OFFSET_Y;

    // constrain to viewport
    if (x - rect.width / 2 < 8) x = rect.width / 2 + 8;
    if (x + rect.width / 2 > vw - 8) x = vw - rect.width / 2 - 8;
    if (y + rect.height > vh - 8) y = Math.max(8, vh - rect.height - 8);

    preview.style.left = `${x}px`;
    preview.style.top = `${y}px`;
  }

  function onMouseMove(e) {
    lastEvent = e;
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      positionPreview(lastEvent);
      rafId = null;
    });
  }

  function showPreview(src, alt, e) {
    if (!src) return;
    
    img.src = src;
    img.alt = alt || '';
    preview.style.display = 'block';
    positionPreview(e);
    document.addEventListener('mousemove', onMouseMove);
  }

  function hidePreview() {
    preview.style.display = 'none';
    img.removeAttribute('src');
    img.removeAttribute('alt');
    document.removeEventListener('mousemove', onMouseMove);
  }

  const menuRoot = document.querySelector('.mega-menu');
  if (!menuRoot) return;

  menuRoot.addEventListener('mouseenter', (e) => {
    const link = e.target.closest('.level-3');
    if (!link || !menuRoot.contains(link)) return;
    const src = link.getAttribute('data-preview-image');
    const alt = link.getAttribute('data-preview-alt') || link.textContent?.trim();
    if (src) showPreview(src, alt, e);
  }, true);

  menuRoot.addEventListener('mouseleave', (e) => {
    const link = e.target.closest('.level-3');
    if (!link || !menuRoot.contains(link)) return;
    hidePreview();
  }, true);

  menuRoot.addEventListener('mouseleave', (e) => {
    if (!e.relatedTarget || !menuRoot.contains(e.relatedTarget)) hidePreview();
  });

  window.addEventListener('scroll', hidePreview, { passive: true });
  window.addEventListener('resize', hidePreview);


  function directChildrenMatches(parent, selector) {
    try {
      return Array.from(parent.querySelectorAll(':scope > ' + selector));
    } catch (e) {
      return Array.from(parent.children).filter(function (c) {
        return c.matches(selector);
      });
    }
  }

  function getMiddleColumns(columns) {
    var children = Array.from(columns.children);
    if (children.length <= 2) return [];
    return children.slice(1, -1); // all except first and last
  }

  document.addEventListener('click', function (ev) {
    // --- SHOW MORE ---
    var showMore = ev.target.closest('.show-more-occasion');
    if (showMore) {
      ev.preventDefault();

      var columns = showMore.closest('.columns');
      if (!columns) return;

      showMore.style.opacity = '0';

      var middleColumns = getMiddleColumns(columns);

      middleColumns.forEach(function (middle) {
        var toHide = directChildrenMatches(middle, '.level-2, .level-3, .all-themes');
        toHide.forEach(function (el) {

          if (el.classList.contains('dont-hide')) {
            return;
          }

          if (el.dataset._prevDisplay === undefined) {
            el.dataset._prevDisplay = window.getComputedStyle(el).display || '';
          }
          el.style.display = 'none';
        });

        var extra = directChildrenMatches(middle, '.extra-links')[0];
        if (extra) extra.style.display = 'flex';
      });

      return;
    }

    // --- SHOW LESS ---
    var showLess = ev.target.closest('.show-less-occasion');
    if (showLess) {
      ev.preventDefault();

      var columns = showLess.closest('.columns');
      if (!columns) return;

      var showMoreLink = document.querySelector('.show-more-occasion');
      if (showMoreLink) {
        showMoreLink.style.opacity = '1';
      }

      var middleColumns = getMiddleColumns(columns);

      middleColumns.forEach(function (middle) {
        // Show back the .level-2 and .level-3
        var toShow = directChildrenMatches(middle, '.level-2, .level-3, .all-themes');
        toShow.forEach(function (el) {
          el.style.display = el.dataset._prevDisplay || 'block';
        });

        // Hide the .extra-links again
        var extra = directChildrenMatches(middle, '.extra-links')[0];
        if (extra) extra.style.display = 'none';
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    document.getElementById('close-mobile-menu')?.addEventListener('click', function () {
      document.getElementById('mobile-menu')?.classList.remove('open');
      document.body.classList.remove('scroll-lock');
    });

    if (document.body.classList.contains('is-mobile-device')) {
      const mobileMenu = document.getElementById('mobile-menu');
      if (mobileMenu) {
        mobileMenu.style.minHeight = 0;
        mobileMenu.style.height = window.innerHeight + 'px';
      }
    }

    var hamburgerButton = document.querySelector('.en-hamburger');
    var mobileMenu = document.getElementById('mobile-menu');
    var header = document.querySelector('header');

    if (hamburgerButton) {
        hamburgerButton.addEventListener('click', function(event) {
            hamburgerButton.classList.toggle('is-active');
            mobileMenu.classList.toggle('open');
            document.body.classList.add('scroll-lock');

            event.preventDefault();
            return false;
        });
    }

    /* Submenu */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.open-submenu');
    if (!trigger) return;

    // stop link navigation (e.g., href="#")
    if (trigger.tagName === 'A') e.preventDefault();

    // direct parent only
    const li = trigger.parentElement;
    if (li && li.tagName === 'LI') {
      li.classList.toggle('open');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-filters"] && !Shopify.designMode) return;
  try {
    const filterPanel = document.getElementById('product-filters');
const openButtons = document.querySelectorAll('.open-product-filters');
const closeButton = document.getElementById('close-product-filters');

// Open filters
openButtons.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    filterPanel.classList.add('open');
    document.body.classList.add('scroll-lock');
  });
});

// Close filters
closeButton?.addEventListener('click', e => {
  e.preventDefault();
  filterPanel.classList.remove('open');
  document.body.classList.remove('scroll-lock');
});

// Show more / less
filterPanel.querySelectorAll('.filter-group').forEach(facet => {
  const list = facet.querySelector('.facet__values');
  const btn  = facet.querySelector('.facet__show-more');
  if (!btn || !list) return;

  btn.addEventListener('click', e => {
    e.preventDefault();
    const hiddenItems = list.querySelectorAll('.facet__value.is-hidden');
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      hiddenItems.forEach(li => li.style.display = 'none');
      btn.textContent = btn.dataset.show;
      btn.setAttribute('aria-expanded', 'false');
    } else {
      hiddenItems.forEach(li => li.style.display = 'block');
      btn.textContent = btn.dataset.hide;
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

// Disable Apply if nothing changed
const form = document.getElementById('facets-form');
const applyBtn = form?.querySelector('.facets__apply');
if (form && applyBtn) {
  const initial = new URLSearchParams(window.location.search);
  const isFilterParam = (name) => name.startsWith('filter.');

  const snapshot = () => {
    const p = new URLSearchParams();
    form.querySelectorAll('input[name], select[name]').forEach(el => {
      if ((el.type === 'checkbox' && el.checked) || (el.type !== 'checkbox' && el.value)) {
        p.append(el.name, el.value);
      }
    });
    if (initial.get('sort_by')) p.set('sort_by', initial.get('sort_by'));
    if (initial.get('q')) p.set('q', initial.get('q'));
    return p.toString();
  };

  const initialFiltered = Array.from(initial.entries())
    .filter(([k]) => isFilterParam(k) || k === 'sort_by' || k === 'q')
    .map(([k,v]) => `${k}=${v}`).sort().join('&');

  const setDisabledState = () => {
    const current = snapshot().split('&').sort().join('&');
    applyBtn.disabled = (current === initialFiltered);
  };

  form.addEventListener('change', setDisabledState);
  setDisabledState();
}

// ===== Live result count (Collection or Search) =====
const countEl  = form?.querySelector('#facets-result-count');
const gridSectionId = form?.dataset.gridSectionId || 'main-collection-product-grid';

// Build params from the form
function buildParams() {
  const p = new URLSearchParams();
  form.querySelectorAll('input[name], select[name]').forEach(el => {
    if (el.type === 'checkbox') {
      if (el.checked) p.append(el.name, el.value);
    } else if (el.value) {
      p.set(el.name, el.value);
    }
  });
  return p;
}

async function updateCount() {
  if (!form || !countEl) return;

  try {
    applyBtn?.setAttribute('aria-busy', 'true');

    const params = buildParams();
    params.set('section_id', gridSectionId);

    // Use the form's action (collection URL or /search)
    const base = form.getAttribute('action') || window.location.pathname;
    const url  = `${base}?${params.toString()}`;

    const res  = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Network response was not ok');

    const html = await res.text();
    const doc  = new DOMParser().parseFromString(html, 'text/html');

    const newCountEl = doc.querySelector('[data-product-count]');

    if (newCountEl) {
      countEl.textContent = newCountEl.textContent.trim();
    }
  } catch (e) {
    console.warn('Failed to update count', e);
  } finally {
    applyBtn?.removeAttribute('aria-busy');
  }
}

// Update on filter changes
form?.addEventListener('change', debounce(updateCount, 250));
form?.addEventListener('input', debounce(updateCount, 250));

// Simple debounce
let t;
function debounce(fn, wait=300) {
  return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    var galleryContainer = document.querySelector('.us-product-media-gallery');
  if (galleryContainer) {

    // Initialize thumbs swiper
    var thumbsEl = galleryContainer.querySelector('.gallery-thumbs');
    var galleryThumbs = new Swiper(thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        freeMode: true,
        watchSlidesProgress: true,
        observeParents: true,
        observer: true,
        breakpoints: {
            1024: {
                spaceBetween: 17
            }
        }
    });

    // Initialize main swiper
    var galleryEl = galleryContainer.querySelector('.gallery');
    var hasVideo = !!galleryEl.querySelector('.is-video-slide');
    var swiper = new Swiper(galleryEl, {
        // Loop mode moves slides around the DOM, which pauses a playing video,
        // so galleries with video wrap around with rewind instead
        loop: !hasVideo,
        rewind: hasVideo,
        thumbs: {
            swiper: galleryThumbs
        },
        navigation: {
            nextEl: '.product-gallery-nav .button-next',
            prevEl: '.product-gallery-nav .button-prev',
        },
        observeParents: true,
        observer: true,
        on: {
            init: function() {
                galleryEl.classList.toggle('is-video-active', !!(this.slides[this.activeIndex] && this.slides[this.activeIndex].classList.contains('is-video-slide')));
            },
            // realIndexChange rather than slideChange: Swiper can fire slideChange when it
            // updates (e.g. the header toggling body.scrolled) without the slide actually changing
            realIndexChange: function() {
                var currentSlideEl = this.el.querySelector('.swiper-fraction > .current-slide');
                if (currentSlideEl) {
                    currentSlideEl.textContent = this.realIndex + 1;
                }

                // Stop any playing video when leaving its slide
                galleryEl.querySelectorAll('[data-us-video]').forEach(function(player) {
                    player.querySelector('video').pause();
                });

                var activeSlide = this.slides[this.activeIndex];
                galleryEl.classList.toggle('is-video-active', !!(activeSlide && activeSlide.classList.contains('is-video-slide')));
            }
        }
    });

    // Branded player for Shopify-hosted videos
    var formatTime = function(seconds) {
        if (!isFinite(seconds)) seconds = 0;
        var m = Math.floor(seconds / 60);
        var s = Math.floor(seconds % 60);
        return m + ':' + (s < 10 ? '0' : '') + s;
    };

    galleryContainer.querySelectorAll('[data-us-video]').forEach(function(player) {
        var video = player.querySelector('video');
        var progress = player.querySelector('[data-us-video-progress]');
        var currentEl = player.querySelector('[data-us-video-current]');
        var durationEl = player.querySelector('[data-us-video-duration]');
        var muteBtn = player.querySelector('[data-us-video-mute]');
        var toggleBtns = player.querySelectorAll('[data-us-video-toggle]');
        var idleTimer;

        var togglePlay = function() {
            if (video.paused || video.ended) {
                video.play();
            } else {
                video.pause();
            }
        };

        var wake = function() {
            player.classList.remove('is-idle');
            clearTimeout(idleTimer);
            if (!video.paused) {
                idleTimer = setTimeout(function() { player.classList.add('is-idle'); }, 2500);
            }
        };

        var updateProgress = function() {
            var pct = video.duration ? (video.currentTime / video.duration) * 100 : 0;
            player.style.setProperty('--us-video-played', pct + '%');
            progress.setAttribute('aria-valuenow', Math.round(pct));
            progress.setAttribute('aria-valuetext', formatTime(video.currentTime) + ' of ' + formatTime(video.duration));
            currentEl.textContent = formatTime(video.currentTime);
        };

        var updateBuffered = function() {
            if (!video.duration || !video.buffered.length) return;
            var end = video.buffered.end(video.buffered.length - 1);
            player.style.setProperty('--us-video-buffered', (end / video.duration) * 100 + '%');
        };

        toggleBtns.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                togglePlay();
            });
        });

        video.addEventListener('click', togglePlay);

        video.addEventListener('play', function() {
            player.classList.add('is-playing', 'has-started');
            toggleBtns.forEach(function(btn) { btn.setAttribute('aria-label', 'Pause video'); });
            wake();
        });

        video.addEventListener('pause', function() {
            player.classList.remove('is-playing', 'is-idle');
            toggleBtns.forEach(function(btn) { btn.setAttribute('aria-label', 'Play video'); });
            clearTimeout(idleTimer);
        });

        video.addEventListener('ended', function() {
            player.classList.remove('has-started');
        });

        video.addEventListener('loadedmetadata', function() {
            durationEl.textContent = formatTime(video.duration);
            updateProgress();
        });

        video.addEventListener('timeupdate', updateProgress);
        video.addEventListener('progress', updateBuffered);

        // Seeking (mouse + touch via pointer events)
        var seekFromEvent = function(e) {
            var rect = progress.getBoundingClientRect();
            var ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
            if (video.duration) {
                video.currentTime = ratio * video.duration;
                updateProgress();
            }
        };

        progress.addEventListener('pointerdown', function(e) {
            e.stopPropagation();
            progress.setPointerCapture(e.pointerId);
            player.classList.add('is-seeking');
            seekFromEvent(e);
        });

        progress.addEventListener('pointermove', function(e) {
            if (player.classList.contains('is-seeking')) seekFromEvent(e);
        });

        ['pointerup', 'pointercancel'].forEach(function(type) {
            progress.addEventListener(type, function() {
                player.classList.remove('is-seeking');
            });
        });

        progress.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowRight') {
                video.currentTime = Math.min(video.currentTime + 5, video.duration || 0);
            } else if (e.key === 'ArrowLeft') {
                video.currentTime = Math.max(video.currentTime - 5, 0);
            } else {
                return;
            }
            e.preventDefault();
            updateProgress();
        });

        muteBtn.addEventListener('click', function() {
            video.muted = !video.muted;
            player.classList.toggle('is-muted', video.muted);
            muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        });

        player.querySelector('[data-us-video-fullscreen]').addEventListener('click', function() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else if (player.requestFullscreen) {
                player.requestFullscreen();
            } else if (video.webkitEnterFullscreen) {
                // iOS Safari only supports native fullscreen on the video element
                video.webkitEnterFullscreen();
            }
        });

        player.addEventListener('pointermove', wake);
        player.addEventListener('focusin', wake);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", function (e) {
  const btn = e.target.closest(".open-parent");
  if (!btn) return;

  const parentLink = btn.closest("a[href]");
  if (parentLink) {
    // Simulate clicking the link
    window.location.href = parentLink.href;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sort-by"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.sort-by');
  if (!container) return;

  const button = container.querySelector('button');
  const list = container.querySelector('#sort-list');
  const options = Array.from(container.querySelectorAll('.popout-list__option'));
  if (!button || !list || !options.length) return;

  // Accessibility setup
  button.setAttribute('aria-haspopup', 'listbox');
  button.setAttribute('aria-expanded', 'false');
  list.setAttribute('role', 'listbox');
  list.setAttribute('tabindex', '-1'); // container can receive focus

  options.forEach((a, idx) => {
    a.setAttribute('role', 'option');
    a.setAttribute('tabindex', '-1');
    // reflect current selection as aria-selected
    const li = a.closest('.popout-list__item');
    const isCurrent = li && li.classList.contains('popout-list__item--current');
    a.setAttribute('aria-selected', isCurrent ? 'true' : 'false');

    // Click applies sort
    a.addEventListener('click', (e) => {
      e.preventDefault();
      applySort(a.dataset.value);
    });

    // Keyboard "enter" on option
    a.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        applySort(a.dataset.value);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusOption(idx + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusOption(idx - 1);
      } else if (e.key === 'Escape') {
        closeList(true);
      }
    });
  });

  // Open/close handlers
  button.addEventListener('click', () => {
    const isOpen = list.getAttribute('data-open') === 'true';
    isOpen ? closeList(false) : openList();
  });

  button.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openList();
      focusOption(0);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      openList();
      focusOption(options.length - 1);
    }
  });

  document.addEventListener('click', (e) => {
    if (!container.contains(e.target)) closeList(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeList(true);
  });

  function openList() {
    list.setAttribute('data-open', 'true');
    button.setAttribute('aria-expanded', 'true');
  }
  function closeList(returnFocus) {
    list.setAttribute('data-open', 'false');
    button.setAttribute('aria-expanded', 'false');
    if (returnFocus) button.focus();
  }
  function focusOption(i) {
    if (!options.length) return;
    const clamped = (i + options.length) % options.length;
    options[clamped].focus();
  }

  function applySort(value) {
    if (!value) return;
    // Update the current option styling immediately (nice UX)
    options.forEach((a) => {
      const li = a.closest('.popout-list__item');
      const isCurrent = a.dataset.value === value;
      a.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
      if (li) li.classList.toggle('popout-list__item--current', isCurrent);
    });

    // Build new URL preserving existing params
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);

    // Shopify supports sort_by on both collection & search.
    // Preserve 'q' on search pages automatically (already handled above).
    window.location.assign(url.toString());
  }

  // Progressive enhancement: hide list initially
  list.setAttribute('data-open', 'false');
  } catch(e) { console.error(e); }
})();

})();
